import { all, put, select, takeEvery } from 'redux-saga/effects';

import { hateoas } from '../../lib/links';
import * as actions from './actions';
import * as constants from './constants';
import * as entityNormalizers from '../../entities/Entity/normalizers';
import * as entityActions from '../../entities/Entity/actions';
import { apiCall, Mappings, Endpoints } from '../../lib/LeanLinkService';
import { request, success, failure } from '../../lib/Actions';
import * as resourceSelectors from '../../entities/Resource/selectors';
import * as paginatedItemsActions from '../../entities/PaginatedItems/actions';

function* postRequested({ payload: { id, form, values, url } }) {
  yield apiCall(
    Mappings.post({ url, payload: values }),
    data => success(actions.POST, { id, form, url })(entityNormalizers.entity(data)),
    failure(actions.POST, { id, form, url }),
  );
}

function* updateRequested({ payload: { id, form, values } }) {
  yield apiCall(
    Mappings.patch({ url: Endpoints.resources.get({ id }), payload: values }),
    data => success(actions.UPDATE, { id, form })(entityNormalizers.entity(data)),
    failure(actions.UPDATE, { id, form }),
  );
}

function* refreshDependencies({ payload }) {
  const id = payload.id || payload.result.id;
  const resource = yield select(resourceSelectors.resourceById, id);
  const links = resource.links ? resource.links.toJS() : [];
  yield put(request(paginatedItemsActions.FETCH)({ url: hateoas(links).get('events') }));
}

function shouldTimelineRefresh(action) {
  // Resource related
  if (action.type === actions.UPDATE.SUCCESS) {
    return true;
  }

  if ([entityActions.PATCH.SUCCESS, entityActions.CREATE.SUCCESS].includes(action.type)
    && ([constants.RESOURCE_TASK_FORM, constants.RESOURCE_FORM_MAIN].includes(action.payload.form)
      || action.payload.url.match(/\/api\/resources\/[0-9a-f\\-]{36}\/gdpr\/emails/))) {
    return true;
  }

  return false;
}

export default function* defaultSaga() {
  yield all([
    takeEvery(actions.POST.REQUEST, postRequested),
    takeEvery(actions.UPDATE.REQUEST, updateRequested),
    takeEvery(shouldTimelineRefresh, refreshDependencies),
  ]);
}

